import React, { useState, useEffect } from 'react';

interface DesignGridProps {
  columns?: number;
  gutter?: number;
  margin?: number;
  color?: string;
  opacity?: number;
}

export const DesignGrid = ({
  columns = 12,
  gutter = 20,
  margin = 24,
  color = '#ffc0cb',
  opacity = 0.3,
}: DesignGridProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      // Toggle grid with Ctrl+G
      if (e.ctrlKey && e.key === 'g') {
        e.preventDefault();
        setIsVisible((prev) => !prev);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, []);

  if (!isVisible) return null;

  return (
    <div
      className="fixed inset-0 pointer-events-none z-[9999]"
      style={{
        paddingLeft: `${margin}px`,
        paddingRight: `${margin}px`,
      }}
    >
      <div
        className="h-full mx-auto grid"
        style={{
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: `${gutter}px`,
          maxWidth: '100%',
        }}
      >
        {Array.from({ length: columns }).map((_, index) => (
          <div
            key={index}
            className="h-full relative"
            style={{
              backgroundColor: color,
              opacity: opacity,
            }}
          >
            <span
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-xs font-bold text-gray-700 rotate-90"
              style={{ opacity: 0.7 }}
            >
              Column {index + 1}
            </span>
          </div>
        ))}
      </div>

      {/* Info panel */}
      <div
        className="fixed bottom-4 right-4 bg-white/90 backdrop-blur-sm p-3 rounded-lg shadow-lg text-xs pointer-events-auto"
        style={{ zIndex: 10000 }}
      >
        <div className="font-bold mb-2 text-gray-800">Design Grid (Ctrl+G)</div>
        <div className="space-y-1 text-gray-600">
          <div>Columns: {columns}</div>
          <div>Gutter: {gutter}px</div>
          <div>Margin: {margin}px</div>
          <div>Type: stretch</div>
          <div>Width: auto</div>
        </div>
      </div>
    </div>
  );
};









